import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserDetailsService } from '../../shared/services/user-details.service';
import { MessageService } from 'primeng/api';
import { AuthService } from '../../_auth/auth.service';

@Component({
  selector: 'app-admin-banner-details',
  standalone: false,
  templateUrl: './admin-banner-details.component.html',
  styleUrl: './admin-banner-details.component.scss',
})
export class AdminBannerDetailsComponent implements OnInit {
  bannerForm: FormGroup;
  dateTime: Date = new Date();
  bannerTypes: any[];
  existingBanners: any[];
  curUserData: any;
  isUpdateForm: boolean = false;
  updBannerId: any = null;
  charCount:number = 0;


  constructor(
    private readonly fb: FormBuilder,
    private readonly userDetailService: UserDetailsService,
    private messageService: MessageService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.curUserData = this.authService.getUserData();
    this.bannerForm = this.fb.group({
      bannerType: ['',Validators.required],
      bannerMessage: ['',Validators.required],
      bannerTitle: ['',Validators.required],
      startDate: ['',Validators.required],
      endDate: ['',Validators.required],
    });

    this.bannerForm.get('bannerMessage')?.valueChanges.subscribe(value => {
        this.charCount = value?.length || 0;
    });

    this.userDetailService.getBannerCategories().subscribe((data) => {
      this.bannerTypes = data;
    });
    this.getActiveAnnouncements();
  }

  handleSubmit() {
    if (this.isUpdateForm) {
      const data = {
        typeId: this.bannerForm.controls['bannerType'].value,
        startDate: this.bannerForm.controls['startDate'].value,
        endDate: this.bannerForm.controls['endDate'].value,
        content: this.bannerForm.controls['bannerMessage'].value,
        title: this.bannerForm.controls['bannerTitle'].value,
        updatedBy: this.curUserData.sub,
        bannerId: this.updBannerId,
      };

      this.userDetailService
        .updateAnnouncement(data)
        .subscribe((results: any) => {
          if (results.message === 'Success') {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Announcement updated.',
            });
            this.handleClear();
            this.getActiveAnnouncements();
          } else {
            this.messageService.add({
              severity: 'failed',
              summary: 'Failed',
              detail: results.message,
            });
          }
        });
    } else {
      const data = {
        typeId: this.bannerForm.controls['bannerType'].value,
        startDate: this.bannerForm.controls['startDate'].value,
        endDate: this.bannerForm.controls['endDate'].value,
        content: this.bannerForm.controls['bannerMessage'].value,
        title: this.bannerForm.controls['bannerTitle'].value,
        addedBy: this.curUserData.sub,
      };

      this.userDetailService.addAnnouncement(data).subscribe((results: any) => {
        if (results.message === 'Success') {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Announcement added.',
          });
          this.handleClear();
          this.getActiveAnnouncements();
        } else {
          this.messageService.add({
            severity: 'failed',
            summary: 'Failed',
            detail: results.message,
          });
        }
      });
    }
  }

  handleClear() {
    this.bannerForm.reset();
    this.isUpdateForm = false;
    this.dateTime = new Date();
  }

  getActiveAnnouncements() {
    this.userDetailService.getAllExistingBanners().subscribe((data) => {
      this.existingBanners = data;
    });
  }

  getCurrentAnnouncement(announcement?: any) {
    this.dateTime = new Date(announcement.startDate);
    this.bannerForm.controls['bannerType'].setValue(announcement.typeId);
    this.bannerForm.controls['startDate'].setValue(announcement.startDate);
    this.bannerForm.controls['endDate'].setValue(announcement.endDate);
    this.bannerForm.controls['bannerMessage'].setValue(announcement.content);
    this.bannerForm.controls['bannerTitle'].setValue(announcement.title);
    this.updBannerId = announcement.bannerId;
    this.isUpdateForm = true;
  }

  removeAnnouncement(announcement?:any)
  {
    const data={
      bannerId : announcement.bannerId
    };

          this.userDetailService.removeAnnouncement(data).subscribe((results: any) => {
        if (results.message === 'Success') {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Announcement removed.',
          });
          this.handleClear();
          this.getActiveAnnouncements();
        } else {
          this.messageService.add({
            severity: 'failed',
            summary: 'Failed',
            detail: results.message,
          });
        }
      });
  }
}
